import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UploadDocumentIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 48 48"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9C6 5.68629 8.68629 3 12 3H29.1339C30.1571 3 31.1413 3.39206 31.8842 4.09553L34.8485 6.90244L38.8017 10.7819C39.5682 11.5341 40 12.5629 40 13.6368V39C40 41.2091 38.2091 43 36 43H12C8.68629 43 6 40.3137 6 37V9Z"
      fill="white"
    />
    <path
      d="M21.5 26C21.5 26.8284 20.8284 27.5 20 27.5H13C12.1716 27.5 11.5 26.8284 11.5 26C11.5 25.1716 12.1716 24.5 13 24.5H20C20.8284 24.5 21.5 25.1716 21.5 26Z"
      fill="#D0D5DD"
    />
    <path
      d="M26 20.5C26.8284 20.5 27.5 19.8284 27.5 19C27.5 18.1716 26.8284 17.5 26 17.5H13C12.1716 17.5 11.5 18.1716 11.5 19C11.5 19.8284 12.1716 20.5 13 20.5H26Z"
      fill="#D0D5DD"
    />
    <path
      clipRule="evenodd"
      d="M31.8842 4.09553L34.8485 6.90244L38.8017 10.7819C39.5682 11.5341 40 12.5629 40 13.6368V39C40 41.2091 38.2091 43 36 43H12C8.68629 43 6 40.3137 6 37V9C6 5.68629 8.68629 3 12 3H29.1339C30.1571 3 31.1413 3.39206 31.8842 4.09553ZM36 42H12C9.23858 42 7 39.7614 7 37V9C7 6.23858 9.23858 4 12 4H29.1339C29.4299 4 29.7215 4.04373 30 4.12773V9C30 11.2091 31.7909 13 34 13H38.9316C38.9767 13.2076 39 13.421 39 13.6368V39C39 40.6569 37.6569 42 36 42Z"
      fill="#D0D5DD"
      fillRule="evenodd"
    />
    <circle cx="32" cy="35" fill="currentColor" r="10" />
    <path
      d="M32 39.3773L32 32.391M35.5352 34.1586L31.9996 30.623L28.4648 34.1586"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

UploadDocumentIcon.propTypes = {
  ...sizePropsTypes,
};

export default UploadDocumentIcon;
